import { Route, Routes } from "react-router";
import AllStations from "./components/AllStations";
import StarredStations from "./components/StarredStations";
import Tabs from "./components/Tabs";
import { StarredProvider } from "./lib/StarredContext";
import Player from "./player/Player";
import { PlayerProvider } from "./player/PlayerContext";

export default function App() {
  return (
    <StarredProvider>
      <PlayerProvider>
        <main className="min-h-screen bg-slate-100 px-4 pt-8 pb-28">
          <div className="mx-auto max-w-3xl">
            <h1 className="mb-6 text-3xl font-bold text-slate-800">Radio stations</h1>
            <Tabs />
            <Routes>
              <Route path="/" element={<AllStations />} />
              <Route path="/starred" element={<StarredStations />} />
            </Routes>
          </div>
        </main>
        <Player />
      </PlayerProvider>
    </StarredProvider>
  );
}
